import { render } from "./DewaelePotentialOffers.vue?vue&type=template&id=288ce1af"
import script from "./DewaelePotentialOffers.vue?vue&type=script&lang=js"
export * from "./DewaelePotentialOffers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__